// Shared single-source-of-truth constants so copy can't drift across the site.

// Phone — the ONLY phone number for Flow Forge Mechanical.
export const PHONE_DISPLAY = "587-355-FLOW (3569)";
export const PHONE_TEL = "+15873553569";
export const PHONE_SMS = "+15873553569";
export const PHONE_SMS_LABEL = "587-355-FLOW";

// Business hours — Mon–Fri 7:00 AM–5:00 PM, closed weekends.
export const BUSINESS_HOURS = {
  weekdays: "Monday – Friday: 7:00 AM – 5:00 PM",
  weekend: "Saturday – Sunday: Closed",
  afterHoursNote:
    "Outside these hours? Send a request or text us and we'll reply the next business day.",
  // Upcoming holiday closures (closed all day)
  holidayClosures: [
    "2026-11-11",
    "2026-12-24",
    "2026-12-25",
    "2026-12-26",
    "2026-12-31",
    "2027-01-01",
  ],
  holidayClosuresNote: "Holiday closures: Nov 11, Dec 24–26, Dec 31–Jan 1",
  // Machine-readable for JSON-LD
  schema: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "07:00",
    closes: "17:00",
  },
};

// External links
export const GBP_REVIEW_URL = "https://g.page/r/CYfuIXCRPjNCEAE/review";
export const INSTAGRAM_URL = "https://www.instagram.com/flow.forge.mechanical/";
export const SITE_URL = "https://flowforgemechanical.ca";
export const SERVICE_EMAIL = "service@flowforgemechanical.ca";

// Feature flags (default OFF until the owner confirms in writing)
export const SHOW_WARRANTY_LINE = true;
export const WARRANTY_LINE = "1-year workmanship warranty, separate from manufacturer warranties";

// Brand
export const BRAND = {
  navy: "#1E3A5F",
  blue: "#3B82F6",
  red: "#DC2626",
};
